import React, { useState, useEffect } from 'react';
import { Radio, Input, Button } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

const colorAttributesConfig = [
  { key: 'None', label: 'None', isDate: false },
  { key: 'initiativeNumber', label: '#', group: 'General', isDate: false },
  { key: 'initiativeName', label: 'Name', group: 'General', isDate: false },
  { key: 'initiativeNumber - initiativeName', label: '# - Name', group: 'General', isDate: false },
  { key: 'weeklyStatus', label: 'Weekly status', group: 'General', isDate: false },
  { key: 'Description', label: 'Description', group: 'General', isDate: false },
  { key: 'AllowOnlyTo', label: 'Access', group: 'General', isDate: false },
  { key: 'workstreamSponsorWorkstream', label: 'Accountable Workstream', group: 'General', isDate: false },
  { key: 'workstreamLeadSubworkstream', label: 'Subworkstream', group: 'General', isDate: false },
  {
    key: 'crossFunctionalSupportWorkstreamInfo',
    label: 'Cross Functional Workstream Support',
    group: 'General',
    isDate: false,
  },
  { label: 'Sector', key: 'sectorInfo', group: 'General', isDate: false },
  { label: 'Subsector', key: 'subsectorInfo', group: 'General', isDate: false },
  { label: 'Type', key: 'type', group: 'General', isDate: false },
  { label: 'Initiative Category', key: 'initiativeCategory', group: 'General', isDate: false },
  { label: 'Size', key: 'size', group: 'General', isDate: false },
  { label: 'Segment', key: 'segment', group: 'General', isDate: false },
  { key: 'selectedForToMeetingDescusion', label: 'Select To meeting discussion', group: 'General', isDate: false },

  // Stage
  { key: 'Stage', label: 'Stage', group: 'Stage', isDate: false },
  { key: 'Stage (simplified)', label: 'Stage (simplified)', group: 'Stage', isDate: false },
  {
    key: 'Workstream Lead pending approval?',
    label: 'Workstream Lead pending approval?',
    group: 'Stage',
    isDate: false,
  },
  {
    key: 'Workstream Sponsor pending approval?',
    label: 'Workstream Sponsor pending approval?',
    group: 'Stage',
    isDate: false,
  },
  {
    key: 'Finance lead pending approval?',
    label: 'Finance lead pending approval?',
    group: 'Stage',
    isDate: false,
  },
  {
    key: 'Strategy analyst pending approval?',
    label: 'Strategy analyst pending approval?',
    group: 'Stage',
    isDate: false,
  },

  // Team
  { key: 'initiativeOwnerInfo', label: 'Initiative Owner', group: 'Team', isDate: false },
  { key: 'initiativeOwnerBackupInfo', label: 'Initiative Owner (back-up)', group: 'Team', isDate: false },
  { key: 'workstreamLeadInfo', label: 'Workstream Lead', group: 'Team', isDate: false },
  { key: 'workstreamSponsorInfo', label: 'Workstream Sponsor', group: 'Team', isDate: false },
  { key: 'TO Finance Lead', label: 'TO Finance Lead', group: 'Team', isDate: false },

  // Impact summary
  {
    key: 'Net recurring benefits range (latest estimate, annualized)',
    label: 'Net recurring benefits range (latest estimate, annualized)',
    group: 'Impact summary',
    isDate: false,
  },
  {
    key: 'actualImpactUpdateCheck',
    label: 'Actual impact update check (for last completed and previous periods)',
    group: 'Impact summary',
    isDate: false,
  },
  {
    label: '(FY23-24) Actual impact update check',
    key: '(FY23-24) Actual impact update check',
    group: 'Impact summary',
    isDate: false,
  },
  {
    label: '(FY24-25) Actual impact update check',
    key: '(FY24-25) Actual impact update check',
    group: 'Impact summary',
    isDate: false,
  },

  // Timing information
  { key: 'planningSummary', label: 'Planning summary', group: 'Timing information', isDate: false },
  {
    key: 'Planning summary (simplified)',
    label: 'Planning summary (simplified)',
    group: 'Timing information',
    isDate: false,
  },
  {
    key: 'L3 date compliance check (forecast vs planned date)',
    label: 'L3 date compliance check (forecast vs planned date)',
    group: 'Timing information',
    isDate: false,
  },
  {
    key: 'L4 date compliance check (forecast vs planned date)',
    label: 'L4 date compliance check (forecast vs planned date)',
    group: 'Timing information',
    isDate: false,
  },

  // Dates - Original Planned Dates
  { key: 'L1 Original Planned Date', label: 'L1 Original Planned Date', group: 'Original Planned Dates', isDate: true },
  { key: 'L2 Original Planned Date', label: 'L2 Original Planned Date', group: 'Original Planned Dates', isDate: true },
  { key: 'L3 Original Planned Date', label: 'L3 Original Planned Date', group: 'Original Planned Dates', isDate: true },
  { key: 'L4 Original Planned Date', label: 'L4 Original Planned Date', group: 'Original Planned Dates', isDate: true },
  { key: 'L5 Original Planned Date', label: 'L5 Original Planned Date', group: 'Original Planned Dates', isDate: true },

  // Dates - Original Planned Dates (Fiscal Periods)
  { key: 'L1 Original Plan Year', label: 'L1 Original Plan Year', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L1 Original Planned Date' },
  { key: 'L1 Original Plan Quarter', label: 'L1 Original Plan Quarter', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L1 Original Planned Date' },
  { key: 'L1 Original Plan Month', label: 'L1 Original Plan Month', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L1 Original Planned Date' },
  { key: 'L1 Original Plan Week', label: 'L1 Original Plan Week', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L1 Original Planned Date' },
  { key: 'L2 Original Plan Year', label: 'L2 Original Plan Year', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L2 Original Planned Date' },
  { key: 'L2 Original Plan Quarter', label: 'L2 Original Plan Quarter', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L2 Original Planned Date' },
  { key: 'L2 Original Plan Month', label: 'L2 Original Plan Month', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L2 Original Planned Date' },
  { key: 'L2 Original Plan Week', label: 'L2 Original Plan Week', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L2 Original Planned Date' },
  { key: 'L3 Original Plan Year', label: 'L3 Original Plan Year', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L3 Original Planned Date' },
  { key: 'L3 Original Plan Quarter', label: 'L3 Original Plan Quarter', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L3 Original Planned Date' },
  { key: 'L3 Original Plan Month', label: 'L3 Original Plan Month', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L3 Original Planned Date' },
  { key: 'L3 Original Plan Week', label: 'L3 Original Plan Week', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L3 Original Planned Date' },
  { key: 'L4 Original Plan Year', label: 'L4 Original Plan Year', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L4 Original Planned Date' },
  { key: 'L4 Original Plan Quarter', label: 'L4 Original Plan Quarter', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L4 Original Planned Date' },
  { key: 'L4 Original Plan Month', label: 'L4 Original Plan Month', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L4 Original Planned Date' },
  { key: 'L4 Original Plan Week', label: 'L4 Original Plan Week', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L4 Original Planned Date' },
  { key: 'L5 Original Plan Year', label: 'L5 Original Plan Year', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L5 Original Planned Date' },
  { key: 'L5 Original Plan Quarter', label: 'L5 Original Plan Quarter', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L5 Original Planned Date' },
  { key: 'L5 Original Plan Month', label: 'L5 Original Plan Month', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L5 Original Planned Date' },
  { key: 'L5 Original Plan Week', label: 'L5 Original Plan Week', group: 'Original Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'L5 Original Planned Date' },

  // Dates - Planned Dates
  { key: 'l1PlannedDate', label: 'L1 planned date', group: 'Planned Dates', isDate: true },
  { key: 'l2ForecastDate', label: 'L2 planned date', group: 'Planned Dates', isDate: true },
  { key: 'l3PlannedDate', label: 'L3 planned date', group: 'Planned Dates', isDate: true },
  { key: 'l4PlannedDate', label: 'L4 planned date', group: 'Planned Dates', isDate: true },
  { key: 'l5LatestEstimatedDate', label: 'L5 planned date', group: 'Planned Dates', isDate: true },

  // Dates - Planned Dates (Fiscal Periods)
  { key: 'l1PlanYear', label: 'L1 Plan Year', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l1PlannedDate' },
  { key: 'l1PlanQuarter', label: 'L1 Plan Quarter', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l1PlannedDate' },
  { key: 'l1PlanMonth', label: 'L1 Plan Month', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l1PlannedDate' },
  { key: 'l1PlanWeek', label: 'L1 Plan Week', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l1PlannedDate' },
  { key: 'l2PlanYear', label: 'L2 Plan Year', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ForecastDate' },
  { key: 'l2PlanQuarter', label: 'L2 Plan Quarter', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ForecastDate' },
  { key: 'l2PlanMonth', label: 'L2 Plan Month', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ForecastDate' },
  { key: 'l2PlanWeek', label: 'L2 Plan Week', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ForecastDate' },
  { key: 'l3PlanYear', label: 'L3 Plan Year', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l3PlannedDate' },
  { key: 'l3PlanQuarter', label: 'L3 Plan Quarter', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l3PlannedDate' },
  { key: 'l3PlanMonth', label: 'L3 Plan Month', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l3PlannedDate' },
  { key: 'l3PlanWeek', label: 'L3 Plan Week', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l3PlannedDate' },
  { key: 'l4PlanYear', label: 'L4 Plan Year', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l4PlannedDate' },
  { key: 'l4PlanQuarter', label: 'L4 Plan Quarter', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l4PlannedDate' },
  { key: 'l4PlanMonth', label: 'L4 Plan Month', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l4PlannedDate' },
  { key: 'l4PlanWeek', label: 'L4 Plan Week', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l4PlannedDate' },
  { key: 'l5PlanYear', label: 'L5 Plan Year', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l5LatestEstimatedDate' },
  { key: 'l5PlanQuarter', label: 'L5 Plan Quarter', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l5LatestEstimatedDate' },
  { key: 'l5PlanMonth', label: 'L5 Plan Month', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l5LatestEstimatedDate' },
  { key: 'l5PlanWeek', label: 'L5 Plan Week', group: 'Planned Dates (Fiscal Periods)', isDate: true, parentDate: 'l5LatestEstimatedDate' },

  // Dates - Actual Dates
  { key: 'l0ActualDate', label: 'L0 actual date', group: 'Actual Dates', isDate: true },
  { key: 'l1ActualDate', label: 'L1 actual date', group: 'Actual Dates', isDate: true },
  { key: 'l2ActualDate', label: 'L2 actual date', group: 'Actual Dates', isDate: true },
  { key: 'l3ActualDate', label: 'L3 actual date', group: 'Actual Dates', isDate: true },
  { key: 'l4ActualDate', label: 'L4 actual date', group: 'Actual Dates', isDate: true },
  { key: 'l5ActualDate', label: 'L5 actual date', group: 'Actual Dates', isDate: true },
  { key: 'latestActualDateAllLGates', label: 'Latest actual date (All L gates)', group: 'Actual Dates', isDate: true },

  // Dates - Actual Dates (Fiscal Periods)
  { key: 'l0ActualYear', label: 'L0 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l0ActualDate' },
  { key: 'l0ActualQuarter', label: 'L0 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l0ActualDate' },
  { key: 'l0ActualMonth', label: 'L0 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l0ActualDate' },
  { key: 'l0ActualWeek', label: 'L0 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l0ActualDate' },
  { key: 'l1ActualYear', label: 'L1 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l1ActualDate' },
  { key: 'l1ActualQuarter', label: 'L1 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l1ActualDate' },
  { key: 'l1ActualMonth', label: 'L1 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l1ActualDate' },
  { key: 'l1ActualWeek', label: 'L1 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l1ActualDate' },
  { key: 'l2ActualYear', label: 'L2 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ActualDate' },
  { key: 'l2ActualQuarter', label: 'L2 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ActualDate' },
  { key: 'l2ActualMonth', label: 'L2 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ActualDate' },
  { key: 'l2ActualWeek', label: 'L2 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l2ActualDate' },
  { key: 'l3ActualYear', label: 'L3 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l3ActualDate' },
  { key: 'l3ActualQuarter', label: 'L3 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l3ActualDate' },
  { key: 'l3ActualMonth', label: 'L3 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l3ActualDate' },
  { key: 'l3ActualWeek', label: 'L3 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l3ActualDate' },
  { key: 'l4ActualYear', label: 'L4 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l4ActualDate' },
  { key: 'l4ActualQuarter', label: 'L4 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l4ActualDate' },
  { key: 'l4ActualMonth', label: 'L4 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l4ActualDate' },
  { key: 'l4ActualWeek', label: 'L4 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l4ActualDate' },
  { key: 'l5ActualYear', label: 'L5 Actual Year', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l5ActualDate' },
  { key: 'l5ActualQuarter', label: 'L5 Actual Quarter', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l5ActualDate' },
  { key: 'l5ActualMonth', label: 'L5 Actual Month', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l5ActualDate' },
  { key: 'l5ActualWeek', label: 'L5 Actual Week', group: 'Actual Dates (Fiscal Periods)', isDate: true, parentDate: 'l5ActualDate' },

  // Dates - Submission Dates
  { key: 'subForL1ApprovDate', label: 'Sub. for L1 approv. date', group: 'Submission Dates', isDate: true },
  { key: 'subForL2ApprovDate', label: 'Sub. for L2 approv. date', group: 'Submission Dates', isDate: true },
  { key: 'subForL3ApprovDate', label: 'Sub. for L3 approv. date', group: 'Submission Dates', isDate: true },
  { key: 'subForL4ApprovDate', label: 'Sub. for L4 approv. date', group: 'Submission Dates', isDate: true },
  { key: 'subForL5ApprovDate', label: 'Sub. for L5 approv. date', group: 'Submission Dates', isDate: true },

  // Dates - Cancellation
  { key: 'cancellationDate', label: 'Cancellation date', group: 'Cancellation', isDate: true },
  { key: 'cancellationYear', label: 'Cancellation Year', group: 'Cancellation (Fiscal Periods)', isDate: true, parentDate: 'cancellationDate' },
  { key: 'cancellationQuarter', label: 'Cancellation Quarter', group: 'Cancellation (Fiscal Periods)', isDate: true, parentDate: 'cancellationDate' },
  { key: 'cancellationMonth', label: 'Cancellation Month', group: 'Cancellation (Fiscal Periods)', isDate: true, parentDate: 'cancellationDate' },
  { key: 'cancellationWeek', label: 'Cancellation Week', group: 'Cancellation (Fiscal Periods)', isDate: true, parentDate: 'cancellationDate' },

  // KPI summary
  {
    key: 'actualKpiUpdateCheck',
    label: 'Actual KPI update check (for last completed and previous periods)',
    group: 'KPI summary',
    isDate: false,
  },
  {
    key: 'UniversalKPI',
    label: 'Universal KPI',
    group: 'KPI summary',
    isDate: false,
  },
  {
    key: 'TypeOfKPI',
    label: 'Type Of KPI',
    group: 'KPI summary',
    isDate: false,
  },

  // Change (current vs last week)
  {
    key: 'Pipeline weekly variance (L0+)',
    label: 'Pipeline weekly variance (L0+)',
    group: 'Change (current vs last week)',
    isDate: false,
  },
  {
    key: 'Pipeline weekly variance (L1+)',
    label: 'Pipeline weekly variance (L1+)',
    group: 'Change (current vs last week)',
    isDate: false,
  },
  {
    key: 'Pipeline weekly variance (L2+)',
    label: 'Pipeline weekly variance (L2+)',
    group: 'Change (current vs last week)',
    isDate: false,
  },
  {
    key: 'Pipeline weekly variance (L3+)',
    label: 'Pipeline weekly variance (L3+)',
    group: 'Change (current vs last week)',
    isDate: false,
  },
  {
    key: 'Pipeline weekly variance (L4+)',
    label: 'Pipeline weekly variance (L4+)',
    group: 'Change (current vs last week)',
    isDate: false,
  },

  // Other
  { key: 'Number of Attachment', label: 'Number of Attachment', group: 'Other', isDate: false },
  { key: 'Has qualitative KPI?', label: 'Has qualitative KPI?', group: 'Other', isDate: false },
  { key: 'hasFinancialImpact', label: 'Has financial impacts?', group: 'Other', isDate: false },
  { key: 'forSpecificCustomer', label: 'Is Customer Related?', group: 'Other', isDate: false },
  { key: 'segmentalPBT', label: 'Segmental PBT', group: 'Other', isDate: false },

  // Sequencing
  {
    key: 'Future implementation costs range',
    label: 'Future implementation costs range',
    group: 'Sequencing',
    isDate: false,
  },
];

const ColorContent = ({ colorByAttribute, setColorByAttribute, selectedMenu }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isClearVisible, setIsClearVisible] = useState(false);
  const [expandedDates, setExpandedDates] = useState({});

  const handleClear = () => {
    setColorByAttribute('None');
    // Also clear any expanded date states
    setExpandedDates({});
  };

  useEffect(() => {
    setIsClearVisible(colorByAttribute !== 'None' && colorByAttribute !== null);
  }, [colorByAttribute]);

  const handleDateGroupingSelect = (parentKey, groupingLevel) => {
    // When a date grouping is selected, set the colorByAttribute to the appropriate child attribute
    // For example, if L1 Original Planned Date is selected with "Year" grouping,
    // we set colorByAttribute to 'L1 Original Plan Year'
    let childKey = null;

    switch (groupingLevel) {
      case 'Year':
        childKey = colorAttributesConfig.find(attr => attr.parentDate === parentKey && attr.key.includes('Year'))?.key;
        break;
      case 'Quarter':
        childKey = colorAttributesConfig.find(attr => attr.parentDate === parentKey && attr.key.includes('Quarter'))?.key;
        break;
      case 'Month':
        childKey = colorAttributesConfig.find(attr => attr.parentDate === parentKey && attr.key.includes('Month'))?.key;
        break;
      case 'Week':
        childKey = colorAttributesConfig.find(attr => attr.parentDate === parentKey && attr.key.includes('Week'))?.key;
        break;
      case 'Day':
        childKey = parentKey; // Use the original date for day grouping
        break;
      default:
        childKey = parentKey;
    }

    if (childKey) {
      setColorByAttribute(childKey);
    } else {
      setColorByAttribute(parentKey);
    }
  };

  const filteredAttributes = colorAttributesConfig.filter((attribute) =>
    attribute.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const groupedAttributes = {};
  filteredAttributes.forEach((attr) => {
    if (attr.group) {
      if (!groupedAttributes[attr.group]) {
        groupedAttributes[attr.group] = [];
      }
      groupedAttributes[attr.group].push(attr);
    } else {
      if (!groupedAttributes['']) {
        groupedAttributes[''] = [];
      }
      groupedAttributes[''].push(attr);
    }
  });

  // Check if we're in TableView mode
  const isTableView = selectedMenu?.key === 'Table';

  // Get child date attributes for a parent date
  const getChildDateAttributes = (parentKey) => {
    return colorAttributesConfig.filter(attr => attr.parentDate === parentKey);
  };

  // Check if any child of a parent date is currently selected
  const isParentDateSelected = (parentKey) => {
    const children = getChildDateAttributes(parentKey);
    return children.some(child => child.key === colorByAttribute) || colorByAttribute === parentKey;
  };

  const toggleDateExpand = (attrKey) => {
    setExpandedDates(prev => ({
      ...prev,
      [attrKey]: !prev[attrKey]
    }));
  };

  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <Input
          placeholder="Search attributes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          allowClear
          style={{ flex: 1 }}
        />
        {isClearVisible && (
          <Button
            type="text"
            onClick={handleClear}
            style={{ padding: '0 8px', color: '#ff4d4f' }}
            icon={<CloseCircleOutlined />}
          >
            Clear
          </Button>
        )}
      </div>

      <Radio.Group value={colorByAttribute} onChange={(e) => setColorByAttribute(e.target.value)} style={{ width: '100%' }}>
        {Object.entries(groupedAttributes).map(([groupName, attributes]) => (
          <div key={groupName}>
            {groupName && (
              <div style={{
                fontWeight: 'bold',
                marginTop: '12px',
                marginBottom: '8px',
                fontSize: 13,
                color: '#1890ff',
                borderBottom: '1px solid #f0f0f0',
                paddingBottom: '4px'
              }}>
                {groupName}
              </div>
            )}
            {attributes.map((attr) => {
              // Don't show child date attributes as separate options - they will be shown under their parent
              if (attr.parentDate) return null;

              const isSelected = colorByAttribute === attr.key ||
                (attr.isDate && getChildDateAttributes(attr.key).some(child => child.key === colorByAttribute));

              return (
                <div key={attr.key} style={{ marginBottom: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: groupName ? '16px' : '0' }}>
                    <Radio
                      value={attr.key}
                      style={{ display: 'block' }}
                      disabled={attr.key === 'None'}
                      checked={isSelected}
                    >
                      <span style={{ fontSize: '13px' }}>{attr.label}</span>
                    </Radio>
                    {isTableView && attr.isDate && (
                      <Button
                        type="link"
                        size="small"
                        onClick={() => toggleDateExpand(attr.key)}
                        style={{ marginLeft: '8px', padding: '0 4px' }}
                      >
                        {expandedDates[attr.key] ? '−' : '+'}
                      </Button>
                    )}
                  </div>

                  {/* Show date grouping options when expanded */}
                  {isTableView && attr.isDate && expandedDates[attr.key] && (
                    <div style={{ paddingLeft: '32px', marginTop: '5px', marginBottom: '8px' }}>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                        Color by:
                      </div>
                      <Radio.Group
                        onChange={(e) => handleDateGroupingSelect(attr.key, e.target.value)}
                        value={
                          // Determine which grouping is currently selected
                          getChildDateAttributes(attr.key).find(child => child.key === colorByAttribute)?.key?.includes('Year') ? 'Year' :
                            getChildDateAttributes(attr.key).find(child => child.key === colorByAttribute)?.key?.includes('Quarter') ? 'Quarter' :
                              getChildDateAttributes(attr.key).find(child => child.key === colorByAttribute)?.key?.includes('Month') ? 'Month' :
                                getChildDateAttributes(attr.key).find(child => child.key === colorByAttribute)?.key?.includes('Week') ? 'Week' :
                                  colorByAttribute === attr.key ? 'Day' : 'Day'
                        }
                        size="small"
                      >
                        <Radio value="Year" style={{ display: 'block', marginBottom: '4px' }}>Year</Radio>
                        <Radio value="Quarter" style={{ display: 'block', marginBottom: '4px' }}>Quarter</Radio>
                        <Radio value="Month" style={{ display: 'block', marginBottom: '4px' }}>Month</Radio>
                        <Radio value="Week" style={{ display: 'block', marginBottom: '4px' }}>Week</Radio>
                        <Radio value="Day" style={{ display: 'block', marginBottom: '4px' }}>Day</Radio>
                      </Radio.Group>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </Radio.Group>

      {colorByAttribute && colorByAttribute !== 'None' && (
        <div style={{
          marginTop: '16px',
          padding: '8px',
          backgroundColor: '#f6f6f6',
          borderRadius: '4px',
          fontSize: '12px',
          color: '#666'
        }}>
          <span>Color coding active for: <strong>{colorAttributesConfig.find(attr => attr.key === colorByAttribute)?.label || colorByAttribute}</strong></span>
        </div>
      )}
    </div>
  );
};

export default ColorContent;